
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 19 19\" id=\"facebook_befc3da949285848b418dfdd925b1481\" ><title>Facebook</title><path d=\"M.997 18A.995.995 0 0 1 0 17.006V.993C0 .445.446 0 .997 0h16.07c.551 0 .998.445.998.993v16.013a.995.995 0 0 1-.997.994h-4.604v-6.97h2.348l.352-2.717h-2.7V6.578c0-.786.22-1.322 1.351-1.322h1.444v-2.43a19.367 19.367 0 0 0-2.104-.107c-2.081 0-3.506 1.266-3.506 3.59v2.004H7.295v2.716h2.354V18H.997z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "facebook_befc3da949285848b418dfdd925b1481");


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/sprite/facebook.svg
 ** module id = 223
 ** module chunks = 0
 **/